import React from 'react'
import LocalizedLegalDocument from './LocalizedLegalDocument'

export default function TermsOfService() {
  return <LocalizedLegalDocument documentKey='terms' />
}
